import React, { useState, useEffect } from "react";
import api from "../api/axios";
import DiffModal from "../components/DiffModal";
import "../assets/custom.css";

function HistoryLog() {
  const [groupedList, setGroupedList] = useState([]);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const token = localStorage.getItem("accessToken");
  const branch_id = sessionStorage.getItem("selectedContext")
        ? JSON.parse(sessionStorage.getItem("selectedContext")).branch
        : 0;

  // -----------------------------
  // FETCH HISTORY (GROUPED BY voucher_id)
  // -----------------------------
  const fetchHistoryList = async () => {
    try {
      const res = await api.get("/transaction-history-all/"+branch_id, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setGroupedList(res.data.data || []);
    } catch (err) {
      console.error("History fetch error:", err);
    }
  };

  useEffect(() => {
    fetchHistoryList();
  }, []);

  const openHistoryDetail = (log) => {
    setSelectedHistory(log);
    setModalOpen(true);
  };

return (
    <div className="card p-3">
        <h4 className="mb-3">General Journal Entry History</h4>

        {groupedList.length === 0 && (
            <p className="text-center text-muted mt-3">No history found</p>
        )}

        {groupedList.map((voucher) => (
            <div key={voucher.voucher_id} className="mb-2">
                <h5 className="history-header">
                    <strong>Reference No.:</strong> {voucher.series_no} &nbsp;
                    <span className="text-muted">(Voucher No.: {voucher.voucher_no} - Voucher Date: {voucher.voucher_date})</span>
                </h5>

                <table className="table table-bordered table-hover history-table">
                    <thead className="table-light">
                        <tr>
                            <th>Reason</th>
                            <th>Edited By</th>
                            <th>Updated Time</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {voucher.logs.map((log) => (
                            <tr key={log.id}>
                                <td width="40%">{log.reason}</td>
                                <td>{log.editor}</td>
                                <td>{new Date(log.updated_at).toLocaleString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                    hour12: false,
                                })}</td>
                                <td>
                                    <button
                                        className="btn btn-primary btn-sm history-btn"
                                        onClick={() => openHistoryDetail(log)}
                                    >
                                        View Diff
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        ))}

        {/* DIFF MODAL */}
        {modalOpen && (
            <DiffModal
                history={selectedHistory}
                onClose={() => setModalOpen(false)}
            />
        )}
    </div>
);
}

export default HistoryLog;